import script from "./HotkeyDoc.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotkeyDoc.vue?vue&type=script&lang=ts&setup=true"

import "./HotkeyDoc.vue?vue&type=style&index=0&id=a0322054&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0322054"]])

export default __exports__